import initialState from 'reducers/initialState';
import * as types from 'actions/actionTypes';

// DESA-2607: slice AISLADO de la grilla "sin venta". No comparte estado con
// reducerHomologationProductList para no interferir con el flujo de homologación.
export default function (state = initialState.reducerNoSalesProductList, action) {
  switch (action.type) {
    case types.NO_SALES_PRODUCT_LIST_PENDING:
      // Arranca/reintenta la carga: limpia error y marca como no cargado (muestra spinner).
      return {
        ...state,
        productListLoaded: false,
        error: false,
      }
    case types.NO_SALES_PRODUCT_LIST_FULFILLED:
      return {
        ...state,
        externalProductList: action.payload.data.externalProducts,
        productListLoaded: true,
        error: false,
      }
    case types.NO_SALES_PRODUCT_LIST_REJECTED:
      // Timeout (7 min) o error de datos: marca error para que la UI lo muestre.
      return {
        ...state,
        externalProductList: [],
        productListLoaded: false,
        error: true,
        reason: action.payload.message ? action.payload.message : 'No se pudieron obtener los productos sin venta'
      }
    case types.BLOCK_NO_SALES_FULFILLED:
      // Actualiza SOLO la fila bloqueada en ESTE slice (no toca el principal).
      return {
        ...state,
        externalProductList: state.externalProductList.map((externalProduct) =>
          externalProduct.g_external_product_relationship_id === action.payload.data.g_external_product_relationship_id
            ? action.payload.data
            : externalProduct
        )
      }
    default:
      return state;
  }
}
